import React from 'react';
import './PublicBuildings.css';

const PublicBuildings = () => {
  return (
    <section className="public-buildings">
      <div className="public-buildings-wrapper">
        <h2 className="public-buildings-section-title">Public Buildings Development</h2>
        <div className="public-buildings-grid">
          <div className="public-buildings-card">
            <h3>Administrative Buildings</h3>
            <p>
              Renovation and construction of LGA secretariat offices to provide conducive environments for effective governance and staff productivity.
            </p>
          </div>
          <div className="public-buildings-card">
            <h3>Community Centers</h3>
            <p>
              Development of multipurpose halls and town union offices to foster community engagement, meetings, and social development programs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PublicBuildings;